// tabsSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
export interface TabsData {
  activeTab: string;
  subMenuActive: string
}

interface TabsState {
  tabs: TabsData;
  type: string;
}

const initialState: TabsState = {
  tabs: {
    activeTab: 'dashboard',
    subMenuActive: ''
  },
  type: "1"
};

const tabsSlice = createSlice({
  name: 'tabs',
  initialState,
  
  reducers: {
    resetTabsData: (state) => {
      state.tabs = initialState.tabs;
      state.type = initialState.type;
    },
    setActiveTab: (state, action: PayloadAction<string>) => {
      state.tabs.activeTab = action.payload;
      localStorage.setItem("activeTab", action.payload);
    },
    setSubMenuActiveTab: (state, action: PayloadAction<string>) => {
      state.tabs.subMenuActive = action.payload;
      localStorage.setItem("activeSubMenu", action.payload);
    },
    setActiveType: (state, action: PayloadAction<string>) => {
      state.type = action.payload;
      localStorage.setItem("type", action.payload);
    }
  },
  
});

export const { resetTabsData, setActiveTab, setSubMenuActiveTab, setActiveType } = tabsSlice.actions;
export default tabsSlice.reducer;
